// "All caught up" versus "nobody has checked", which are not the same thing.
//
// `HubView.chores` is nullable as of 2026-09-17 and null means NOT COMPUTED
// (audit 3.7). An empty list is not silent — it renders as "All caught up.
// Enjoy the week." — and saying that to somebody with an unanswered trade
// offer is worse than saying nothing at all.
//
// THE SUBTLETY IS THE ONE THAT MAKES THIS A FUNCTION rather than a `??`: a
// null from a half with no leagues in it carries no information. There was
// nothing to count, so it cannot make the merged list untrustworthy. Without
// that, the simulator's demo hub — the one half that genuinely does compute
// chores — would go silent for everybody, because the league store answers
// null unconditionally today.
//
// It lived inside `hooks.ts` until 2026-09-20, unexported and untested, which
// is what let its previous version carry a rule of its own — treat the list
// as trustworthy only when there are no real leagues — that existed nowhere
// in the contract. Nothing would have noticed that rule coming back
// (AUDIT-2026-09-19 F23).

import type { Chore } from '@fsp/domain';

/**
 * Two halves into one list, or into "nobody counted".
 *
 * `realLeagues` is how many leagues the server half holds, which is what
 * decides whether its null means anything.
 */
export function mergeChores(
  realLeagues: number,
  real: Chore[] | null,
  simulated: Chore[] | null,
): Chore[] | null {
  if (realLeagues > 0 && real === null) return null;
  return [...(real ?? []), ...(simulated ?? [])];
}
